import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import mq from '../../../../../commons/styles/mediaQueries';
import S from '../style/Dac7TabContent';
import { useI18n } from '../../../../../i18n';
import styled from '../../../../../theme/styled';
import { Dac7FormValidationResult } from '../../../../../../typings/dac7';

const Dac7DesktopTabContentWrapper = styled.div`
  display: none;
  ${mq.desktop} {
    display: flex;
  }

  > section {
    width: 100%;
  }
`;

const Dac7MobileTabContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  ${mq.desktop} {
    display: none;
  }
`;

const CheckboxWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const LabelContainer = styled(Paragraph4)`
  color: #406367;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
`;

const ErrorMessageContainer = styled(LabelContainer)`
  color: #ff5636;
  margin-top: 8px;
`;
const CheckBoxContainer = styled.fieldset`
  border: none;
  padding-left: 0;
  > label {
    display: flex;
    flex-direction: row;
    align-items: center;

    & > input[type='checkbox'] {
      border: 4px solid #002f34;
      border-radius: 4px;
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
  }
`;

interface CheckboxProps {
  id: string;
  name: `dac7_${string}`;
  label: string;
  hasValidationError: boolean;
}

const Checkbox = memo(({ id, label, name, hasValidationError }: CheckboxProps) => {
  const i18n = useI18n();
  const [checked, setChecked] = useState(false);
  const onChange = useCallback(() => setChecked(curValue => !curValue), []);

  return (
    <CheckBoxContainer>
      <label htmlFor={id}>
        <input
          type="checkbox"
          id={id}
          name={name}
          onChange={onChange}
          value={checked ? 'on' : 'off'}
        />
        <CheckboxWrapper>
          <LabelContainer>{label}</LabelContainer>
          {hasValidationError && !checked && (
            <ErrorMessageContainer>{i18n('dlv_dac7_t&c_error_message')}</ErrorMessageContainer>
          )}
        </CheckboxWrapper>
      </label>
    </CheckBoxContainer>
  );
});

const Dac7CTABlock = ({
  isDesktop,
  validationResult,
}: {
  isDesktop: boolean;
  validationResult: Dac7FormValidationResult;
}) => {
  const i18n = useI18n();
  const [hasValidationError, setHasValidationError] = useState(false);

  useEffect(() => {
    if (
      validationResult.find(
        res => res?.[0] === 'termsAndConditions' && res?.[1] === 'dlv_dac7_validation_error_t&c',
      )
    ) {
      setHasValidationError(true);
    } else {
      setHasValidationError(false);
    }
  }, [validationResult]);
  return (
    <>
      {isDesktop ? (
        <Dac7DesktopTabContentWrapper>
          <S.Dac7TabContentWrapper>
            <S.Dac7Fieldset className="dac7-action-button-block">
              <Checkbox
                id="dac7_t&c"
                name="dac7_termsAndConditions"
                label={i18n('dlv_dac7_t&c_label')}
                hasValidationError={hasValidationError}
              />
              <ButtonPrimaryDark type="submit" data-testid="dac7-submit-button">
                {i18n('dlv_dac7_form_cta_submit')}
              </ButtonPrimaryDark>
            </S.Dac7Fieldset>
          </S.Dac7TabContentWrapper>
        </Dac7DesktopTabContentWrapper>
      ) : null}
      {!isDesktop ? (
        <Dac7MobileTabContentWrapper className="dac7-action-button-block">
          <S.Dac7TabContentWrapper>
            <S.Dac7Fieldset>
              <Checkbox
                id="dac7_t&c"
                name="dac7_termsAndConditions"
                label={i18n('dlv_dac7_t&c_label')}
                hasValidationError={hasValidationError}
              />
            </S.Dac7Fieldset>
          </S.Dac7TabContentWrapper>
          <S.Dac7TabContentWrapper>
            <S.Dac7Fieldset>
              <ButtonPrimaryDark type="submit" data-testid="dac7-submit-button">
                {i18n('dlv_dac7_form_cta_submit')}
              </ButtonPrimaryDark>
            </S.Dac7Fieldset>
          </S.Dac7TabContentWrapper>
        </Dac7MobileTabContentWrapper>
      ) : null}
    </>
  );
};

export default Dac7CTABlock;
